import React, { CSSProperties } from 'react';

interface RemoteImageProps {
  url: string;
  style: CSSProperties;
  altText: string;
}

export const RemoteImage = React.memo(
  ({ url, style, altText }: RemoteImageProps) => {
    return <img src={url} style={style} alt={altText} />;
  }
);

RemoteImage.displayName = 'RemoteImage';
